import apiClient from './apiClient';

export interface PlanFormat {
  id: string;
  code: string;
  label: string;
  slug: string;
  raceTypeId: number;
  raceTypeLabel: string;
  backupPlanId: string | null;
  backupPlanName: string | null;
}

export interface BackupInput {
  formatId: string;
  backupPlanId: string | null;
}

export const getPlanFormats = async (): Promise<PlanFormat[]> => {
  const response = await apiClient.get('admin/plan-formats');
  return response.data as PlanFormat[];
};

export const savePlanFormatBackups = async (backups: BackupInput[]): Promise<PlanFormat[]> => {
  const response = await apiClient.put('admin/plan-formats/backup', { backups });
  return response.data as PlanFormat[];
};
